import React from 'react';
import { FaUsers, FaClock, FaChartLine, FaUserSecret } from 'react-icons/fa';
import InteractiveBarChart from './BarChart';
import AgeSegmentLineChart from './LineChart';
import RollingShowcase from './RollingShowcase';
import "../styles/metric_generator.css";

const MetricGenerator = () => {
    return (
        <div className="metric-generator">
            {/* Main Content */}
            <div className="content">
                <div >
                    <h1>FramSys AI Sensor</h1>
                    <p>Ever wondered how many customers you had at 13:00 pm? How many women responded to your marketing campaign? Using our metric solutions, you can now get the data!</p>
                
                </div>
              

                <section id="overview">
              
<div class="grid-2x2">
    <div class="grid-item customers-today">
        <div class="item-content">
        <div class="text">
            <h3>See your Customers Demographics</h3>
            <ul>
            <li>Men / Women </li>
            <li>Age Segement</li>
            <li>Visitor Counter</li>
            </ul>
        </div>
        <FaUsers className="grid-item-icon" />
        </div>
    </div>

    <div class="grid-item popular-time-day">
        <div class="item-content centered">
        <FaClock className="grid-item-icon" />
        <h3>Know the Popular Time & Day</h3>
        <ul>
            <li>Most Visited Time: HH:MM</li>
            <li>Most Visited Day: Weekday</li>
        </ul>
        </div>
    </div>

    <div class="grid-item insights-reports">
        <div class="item-content">
        <FaChartLine className="grid-item-icon" />
        <div class="text">
            <h3>Get Insights & Reports</h3>
            <ul>
            <li>Automated Reports</li>
            <li>Interactive Dashboard</li>
            </ul>
        </div>
        </div>
    </div>

    <div class="grid-item anonymous-safe">
        <div class="item-content centered">
        <FaUserSecret className="grid-item-icon" />
        <h3>Anonymous & Safe</h3>
        <ul>
            <li>No Personal Data</li>
            <li>Secure Processing</li>
            <li>Easy Setup</li>
        </ul>
        </div>
    </div>

</div>
                    <div className="content-section">
                        <div className="text-column">
                            <h2>What is it?</h2>
                            <p>The metric generator is a <strong>small device </strong>that collects metrics from real world video data, the data is then used to create reports and create insigts</p>

                            <ul className='list-items-dark '>
                                        <li>Small device or custom integrated solutions</li>
                                        <li>Easy to setup, reports thourgh email or direct visiblity</li>
                            </ul>
                        </div>
                        <div className="text-column">
                            <h2>Why <h2 className='text-box'>metrics</h2> matter</h2>
                            <h3>Do you know?</h3>
                                <ul className='list-items-dark '>
                                        <li>How <strong>many visitors</strong> did you have?</li>
                                        <li>What is the <strong>demographics?</strong> Are you popular with the eldery, with men or with women?</li>
                                        <li>Which of the <strong>products </strong> is getting the most attention?</li>
                                        <li>Don't make decisions from <strong>gut feeling</strong>, make smart decisions from real data.</li>
                                </ul>
                        </div>
                    </div>
                </section>

                <section id="reports">
                  <h2>Automated Reports</h2>
                    <p>Our metric generators send data that you can utilize in whatever way you want. We can provide daily/weekly/monthly reports of all the gathered metrics.</p>
                    <div className="content-section">

                        <div className="image-column">
                            <InteractiveBarChart />
                        </div>
                        <div className="image-column">
                            <AgeSegmentLineChart />
                        </div>
                    </div>
                </section>
                <section id="dashboard">
                                <h2>Dashboard Overview</h2>
                                <div className="content-section">
                                    <div className="text-column dashboard-text">
                                        <h3>Easy to Use</h3>
                                        <p>Get a quick overview of your key metrics at a glance:</p>
                                  <p>Dig down into the data that you are interested in by selectin dates and time intervals. 
                            The Dashboard is designed to allow you to quiickly see and analyze trends and patterns.</p>

                                        <h3>Real-Time Data</h3>
                                        <p>The dashboard provides real-time updates on your metrics, allowing you to monitor trends and make data-driven decisions instantly.</p>
                                    </div>
                                    <div className="image-column dashboard-images">
                                        <img src={require('../assets/piechart.png')} alt="Dashboard Chart 1" className="dashboard-image" />
                                        <img src={require('../assets/radarchart.png')} alt="Dashboard Chart 2" className="dashboard-image" />
                                    </div>
                                </div>
                            </section>
                             <RollingShowcase 
                        speed={45} 
                        images={[
                            require('../assets/dashboard_images/1.png'),
                            require('../assets/dashboard_images/2.png'),
                            require('../assets/dashboard_images/3.png'),
                            require('../assets/dashboard_images/4.png'),
                            require('../assets/dashboard_images/5.png'),
                            require('../assets/dashboard_images/6.png'),
                            require('../assets/dashboard_images/7.png')

                        ]} 
                        className="row-4" 
                    />
                   
                <section id="data">
                    <h2>Data Collection</h2>
                    <div className="content-section">
                        <div class="text-column">
                            <h3>Data Points</h3>
                            <p>Our metric generators meticulously collect and categorize specific data points to provide you with actionable insights. Here's what we capture:</p>
                            <ul class='list-items-dark'>
                                <li><strong>Age Groups:</strong> Segment your visitors by age brackets for targeted marketing strategies.</li>
                                <li><strong>Gender:</strong> Understand the gender distribution of your audience to tailor content effectively.</li>
                                <li><strong>Position:</strong> Track the movement and positions of individuals within your space to optimize layout and flow.</li>
                                <li><strong>Time:</strong> Analyze visitor patterns over time to identify peak hours and low traffic periods.</li>
                            </ul>

                        <h3>Data Privacy</h3>
                        <p>The data collected is fully anonymous and will only be used to generate the metrics. We prioritize your privacy and ensure that no personally identifiable information (PII) is stored or shared.</p>

                        <h3>Data Storage</h3>
                        <p>The metrics are stored in either our secure cloud solutions or on-premises infrastructure, depending on your preferences and requirements. This flexibility allows you to choose the storage option that best fits your data security needs.</p>

                        <h3>Video Data Handling</h3>
                        <p><strong>No Video Data is Saved:</strong> Our solutions employ onboard processing, ensuring that no video footage is stored or transmitted. This means that only processed data relevant to the metrics is retained, providing an additional layer of privacy and security.</p>
                    </div>
                    <div class="image-column">
                        <img className="metric-col-image" src={require('../assets/misc/pi.jpg')} alt=""/>
                    </div></div>
                </section>

                <section id="pricing">
                    <h2>Pricing</h2>
                    <div className="content-section">
                        <div class="text-column">

                            <p><strong>Installation of device(s) </strong></p>
                            <ul class='list-items-dark'>
                                <li>Our proffesionals come and install or integrate the devices</li>
                            </ul>
                            <p><strong>Monthly service Fee</strong></p>
                            <ul class='list-items-dark'>
                                <li>Monthly service fee for Dashboards, reports and maintence</li>

                            </ul>
                            <text>Contact us for more information</text>
                        </div>
                    </div>
                  
                </section>

                <section id="setup">
                    <h2>Setup & Installation</h2>
                    <div className="content-section">
                        <div className="text-column">
                            <h3>Installation Process</h3>
                            <p>Our technician will handle the setup and installation of your Metric Generator device, ensuring that it is configured correctly and ready to start collecting data. Below are the steps involved:</p>

                            <ul className='list-items-dark'>
                                <li><strong>Unboxing:</strong> The technician will carefully unbox the device and ensure all components are present.</li>
                                <li><strong>Power Connection:</strong> Connect the device to a power source. Our devices come with a standard power adapter that can be plugged into any electrical outlet.</li>
                                <li><strong>Internet Connection:</strong> Ensure the device is connected to your network via Ethernet or Wi-Fi.</li>
                                <li><strong>Device Placement:</strong> Position the device according to our guidelines to maximize data accuracy and coverage. Our technician will assist you with this step to ensure optimal placement.</li>
                                <li><strong>Initial Testing:</strong> Conduct a brief test to ensure that the device is collecting data correctly and transmitting it as expected.</li>
                            </ul>

                            <p>If you have any specific requirements or questions, feel free to discuss them with our technician during the installation process. We are committed to ensuring your setup is seamless and meets all your needs.</p>
                        </div>
                    </div>
                </section>

           

            </div>
        </div>
    );
};

export default MetricGenerator;
